module.exports = __webpack_public_path__ + "img/logo-easy-testes.bd086242.svg";